export enum PermissionGroup {
  LAW_AGENT = 'PROFESSIONAL_AGENT',
  LAW_IMM = 'PROFESSIONAL_GTS_SAAS',
}
